export const signInInquiry = () => {
    $('form#reg-question .field-signupquestionform-survey2question').on('change.yii', (e) => {
        const $rowOther = $('form#reg-question .form-row--other');

        if (e.target.value === 'other') {
            $rowOther.removeClass('hidden');

            return;
        }

        $rowOther.addClass('hidden');
        $('form#reg-question input#other-kind').val(undefined);
    });
};
